<template>
  <v-card class="com-mb-card tm-mb-obs-list-card">
    <v-col class="com-mb-card-contents pr-0">
      <!-- 読み込み中 -->
      <div
        v-if="
          this.reqParam.appTime != this.tmOverDatasParam.dispTime ||
            this.reqParam.townsAcqTime != this.tmOverDatasParam.townsAcqTime
        "
        class="tm-progress"
      >
        <v-progress-circular
          v-if="
            this.reqParam.appTime != this.tmOverDatasParam.dispTime ||
              this.reqParam.townsAcqTime != this.tmOverDatasParam.townsAcqTime
          "
          indeterminate
          :size="30"
          :width="5"
        ></v-progress-circular>
      </div>
      <!-- 読み込み済み -->
      <div
        v-if="
          this.reqParam.appTime == this.tmOverDatasParam.dispTime &&
            this.reqParam.townsAcqTime == this.tmOverDatasParam.townsAcqTime
        "
      >
        <v-col
          class="tm-no-regist pa-0"
          v-if="!tmOverDatas.swStg || tmOverDatas.swStg.length == 0"
          >{{ this.$store.state.app.config.messageConfig.ovNoRegist }}</v-col
        >
        <!-- 水位計の基準値超過一覧を表示 -->
        <div>
          <v-list
            dense
            no-action
            v-for="(swStg, swStgIdx) in tmOverDatas.swStg"
            :key="swStgIdx"
          >
            <v-list-item
              class="pa-0 tm-obs-list"
              @click="clickObsList(swStg.swofcCd, 300, swStg.swobsCd)"
            >
              <!-- 観測所アイコン -->
              <v-list-item-action class="mr-4">
                <img
                  v-if="swStg.swstgOvlvl === 30"
                  src="/kawabou/img/obs_icons/obs_swstg_start.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="
                    swStg.swstgOvlvl === config.overViewConfig.swstg.dispOvlvl
                  "
                  src="/kawabou/img/obs_icons/obs_swstg_danger.svg"
                  class="tm-icon-telemeter"
                />
                <img
                  v-if="swStg.swstgOvlvl === 90"
                  src="/kawabou/img/obs_icons/obs_swstg_flood.svg"
                  class="tm-icon-telemeter"
                />
              </v-list-item-action>
              <v-list-item-content
                class="tm-list-content-header tm-list-content-inf"
              >
                <!-- 観測所名 -->
                <v-list-item-title class="tm-nm">
                  {{ swStg.swobsNm }}
                </v-list-item-title>
                <!-- 観測日時 -->
                <v-list-item-subtitle class="tm-date">
                  {{ swStg.obsTime }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content class="tm-list-content-inf">
                <!-- 河川名・水系名 -->
                <v-list-item-title class="tm-rvr-nm"
                  >{{ swStg.swrvrNm }}({{
                    swStg.swrsysNm
                  }}水系)</v-list-item-title
                >
                <v-list-item-subtitle class="tm-rvr-item">
                  <v-row class="tm-obs-content">
                    <!--堤防高から -->
                    <v-col class="tm-obs-item mr-6 col-7"
                      >{{ stgMsg.topendStg }}{{ formatStg(swStg.stgHght)
                      }}{{ text.meter }}</v-col
                    >
                    <!-- 品管フラグ -->
                    <v-col class="tm-obs-icon">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-if="swStg.stgQmflg && swStg.stgQmflg != '0'"
                            v-on="on"
                            class="icon-qmflg"
                            >warning</v-icon
                          >
                        </template>
                        <span>{{ text.abnormal }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-col>
  </v-card>
</template>
<script>
import mixin from "./../../lib/mixin.js";
import Util from "./../../lib/util.js";
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "tm-over-swstg-list",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        meter: "m",
        mm: "mm",
        abnormal: "異常のおそれあり",
        river: {
          embankExp: "堤防天端から",
          stgExp: "水位",
          rainExp: "60分雨量",
        },
      },
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[TmOverList] mounted()");
    this.getTmOverDatas();
  },
  computed: {
    /**
     * 表示範囲のテレメータ超過情報
     */
    tmOverDatas: {
      get() {
        return this.$store.state.Telemeter.tmOverDatas;
      },
    },
    /**
     * 表示範囲のパラメータ
     */
    tmOverDatasParam: {
      get() {
        return this.$store.state.Telemeter.tmOverDatasParam;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTime: this.$store.state.app.appTimeRound,
          towns: this.$store.state.map.towns,
          prefs: this.$store.state.map.prefs,
          townsAcqTime: this.$store.state.map.townsAcqTime,
        };
      },
    },
    /**
     * 基準値超過タブフラグ
     */
    tmOverListFlg: {
      get() {
        return this.$store.state.Telemeter.tmOverListFlg;
      },
    },
    /**
     * 水位表示
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /**
     * 水位表示切替メッセージ
     */
    stgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.stg;
      },
    },
    /** 設定情報 */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
  },
  methods: {
    /**
     * 表示範囲のテレメータ超過情報を取得
     */
    getTmOverDatas() {
      this.$log.debug("[TmOverList] getTmOverDatas()");
      // アクセスログ出力
      PageLog.log({
        page_log: "over_sw",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      setTimeout(() => {
        if (this.$store.state.map.prefTownType === "pref") {
          this.$store.dispatch("Telemeter/getTmOvDatasPref", {
            appTime: this.reqParam.appTime,
            prefs: this.reqParam.prefs,
            townsAcqTime: this.reqParam.townsAcqTime,
            isCurrent: this.$store.state.app.isCurrent,
            dispOvlvl: this.config.overViewConfig.swstg.dispOvlvl,
          });
        } else {
          this.$store.dispatch("Telemeter/getTmOvDatas", {
            appTime: this.reqParam.appTime,
            towns: this.reqParam.towns,
            townsAcqTime: this.reqParam.townsAcqTime,
            isCurrent: this.$store.state.app.isCurrent,
            dispOvlvl: this.config.overViewConfig.swstg.dispOvlvl,
          });
        }
      }, 500);
    },
    /** 個別観測所画面へ遷移 */
    clickObsList(ofcCd, itmkndCd, obsCd) {
      this.$log.debug(
        "[TmOverList] clickObsList(" +
          ofcCd +
          "," +
          itmkndCd +
          "," +
          obsCd +
          ")"
      );
      // 水位計の場合
      if (itmkndCd == 300) {
        // 選択中テレメータ情報を設定
        this.$store.commit("Swin/setSelectedSwParam", {
          swofcCd: Number(ofcCd),
          itmkndCd: Number(itmkndCd),
          swobsCd: Number(obsCd),
        });
        // 画面遷移
        this.routerPushTmSw("/mb/tm");
      } else {
        // 選択中テレメータ情報を設定
        this.$store.commit("Telemeter/setSelectedTmParam", {
          ofcCd: Number(ofcCd),
          itmkndCd: Number(itmkndCd),
          obsCd: Number(obsCd),
        });
        // 画面遷移
        this.routerPushTm("/mb/tm");
      }
    },
    /**
     * 水位を小数第2位に変換
     */
    formatStg(stg) {
      this.$log.debug("[TmOverList] formatStg(" + stg + ")");
      return Util.formatFloat(stg, 2);
    },
  },
  watch: {
    /**
     * リクエストパラメータ変更時
     */
    reqParam() {
      this.$log.debug("[TmOverList] reqParam()");
      // 表示時刻、取得時刻が変更された場合にJsonファイルを取得
      if (
        this.reqParam.appTime != this.tmOverDatasParam.dispTime ||
        this.reqParam.townsAcqTime != this.tmOverDatasParam.townsAcqTime
      ) {
        this.getTmOverDatas();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tm-icon-telemeter {
  width: 26px;
}
.tm-no-regist {
  font-size: 0.9rem;
}

.tm-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
